// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import { GLYPH_VIEWBOX, GLYPH_STROKE } from './glyph';
import type { SymbolGlyphProps } from './glyph';
import { Leads } from './Leads';

/**
 * Battery energy storage — alternating long and short plates.
 *
 * The standard cell symbol, repeated twice for a stack. It is the same mark
 * that distinguishes the `dc` conductor, which is deliberate: a BESS and the DC
 * link it sits on should be recognisable as the same kind of thing.
 */
export const BatterySymbol = ({ size = 18, leads }: SymbolGlyphProps) => (
  <svg
    width={size}
    height={size}
    viewBox={GLYPH_VIEWBOX}
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <line x1="4.5" y1="8" x2="19.5" y2="8" stroke="currentColor" strokeWidth={GLYPH_STROKE + 0.4} />
    <line
      x1="8.5"
      y1="11.5"
      x2="15.5"
      y2="11.5"
      stroke="currentColor"
      strokeWidth={GLYPH_STROKE - 0.3}
    />
    <line
      x1="4.5"
      y1="15"
      x2="19.5"
      y2="15"
      stroke="currentColor"
      strokeWidth={GLYPH_STROKE + 0.4}
    />
    <line
      x1="8.5"
      y1="18.5"
      x2="15.5"
      y2="18.5"
      stroke="currentColor"
      strokeWidth={GLYPH_STROKE - 0.3}
    />
    <Leads top={8} bottom={18.5} leads={leads} />
  </svg>
);
